<template>
    <BaseModal
        :id="'static'"
        :title="title"
        :size="''"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <div class="row m-0">
                    <label v-html="`Additional Unassigned WorkSheet`" class="modal-label col-12" for=""/>
                </div>
                <span v-for="(val,index) in form_data.discharge_worksheets" :key="index" class="row m-0 formdynamic justify-content-md-between">
                    <span  class="p-0 formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label v-html="`Minutes`" class="modal-label "/>
                            <input 
                                :disabled="false"
                                :type="'number'" 
                                :class="''"            
                                v-model="form_data.discharge_worksheets[index].minutes"
                            />
                        </div>
                    </span>
                    <span  class="p-0 formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label v-html="`Decription Of Work`" class="modal-label "/>
                            <input 
                                :disabled="false"
                                :type="'text'" 
                                :class="''"             
                                v-model="form_data.discharge_worksheets[index].description"
                            />
                        </div>
                    </span>
                </span>
                <div class="row m-0">
                    <a v-html="`Add More`" href="#" class="d-inline-md-block col-12 text-right" @click="add_more()"></a>
                </div>
                <span class="row m-0 formdynamic justify-content-md-between">
                    <span  class="p-0 formdynamic__item col-md-6">
                        <div class="formdynamic__item__field">
                            <label v-html="`Associate Signature`" class="modal-label"/>
                            <input 
                                :disabled="false"
                                :type="'text'" 
                                :class="''"            
                                v-model="form_data.associate_signature"
                            />
                        </div>
                    </span>
                </span>
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "axios",
        "array_options",
        "breadcrumb",
    ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return {
            levels:                     [],
            areas:                      [],
            form_data:                  FormResources.form_data,
            form_format:                FormResources.form_format,
            form_backup:                {...FormResources.form_data},
        }
    },

    methods:{
        add_more() {
            this.form_data.discharge_worksheets.push({
                minutes:        '',
                description:    ''
            });
        }
    },

    mounted() {
        this.form_data.date = new Date().toISOString().split('T')[0];
    },

    watch: {
        "form_data.daily_assignment_id"(val) {
            if(val) {
                const assignment = this.array_options.daily_assignment_id.find(v => v.id == val);
                this.form_data.associate_id = assignment.associate_id;
            }
        }
    }
    
}
</script>
